import { RepeaterInner } from '../repeater';

export const SectionRepeaterInner = (props: any) => (
  <RepeaterInner defaultLabel="Section Template" name="SectionRepeater" {...props} />
);
